import { render, staticRenderFns } from "./HorsePedigreeSearchField.vue?vue&type=template&id=8afb460c&scoped=true"
import script from "./HorsePedigreeSearchField.vue?vue&type=script&lang=ts"
export * from "./HorsePedigreeSearchField.vue?vue&type=script&lang=ts"
import style0 from "./HorsePedigreeSearchField.vue?vue&type=style&index=0&id=8afb460c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afb460c",
  null
  
)

export default component.exports